import { render } from "./ZentrolinkFooter.vue?vue&type=template&id=26dbbbeb&scoped=true"
import script from "./ZentrolinkFooter.vue?vue&type=script&lang=js"
export * from "./ZentrolinkFooter.vue?vue&type=script&lang=js"

import "./ZentrolinkFooter.vue?vue&type=style&index=0&id=26dbbbeb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26dbbbeb"]])

export default __exports__